export const isBaseUrlV2 = (): boolean => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;

    const rootDomainV2 = process.env.GATSBY_ROOT_DOMAIN_V2 || "";
    if (!!rootDomainV2 && hostname.endsWith(rootDomainV2)) {
      return true;
    }
  }
  return false;
};

export const isBaseUrlV3 = (): boolean => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;

    const rootDomainV3 = process.env.GATSBY_ROOT_DOMAIN_V3 || "";
    if (!!rootDomainV3 && hostname.endsWith(rootDomainV3)) {
      return true;
    }
  }
  return false;
};

export const getRootDomain = (): string => {
  if (isBaseUrlV3()) {
    return process.env.GATSBY_ROOT_DOMAIN_V3 || "";
  }
  if (isBaseUrlV2()) {
    return process.env.GATSBY_ROOT_DOMAIN_V2 || "";
  }
  return process.env.GATSBY_ROOT_DOMAIN || "";
};

export const getSiteUrl = (): string => {
  if (isBaseUrlV3()) {
    return process.env.GATSBY_SITE_URL_V3 || "";
  }
  if (isBaseUrlV2()) {
    return process.env.GATSBY_SITE_URL_V2 || "";
  }
  return process.env.GATSBY_SITE_URL || "";
};

export const getApiBaseUrl = (): string => {
  if (isBaseUrlV3()) {
    return process.env.GATSBY_API_BASE_URL_V3 || "";
  }
  if (isBaseUrlV2()) {
    return process.env.GATSBY_API_BASE_URL_V2 || "";
  }
  return process.env.GATSBY_API_BASE_URL || "";
};

// bnesim.com is blocked in Turkey, so on bne.li the hosts below use their
// bne.li twin (media.bne.li, cc.bne.li, my.bne.li). The `_V3` value when it is
// set, the bnesim.com one otherwise; bnesim.shop keeps the bnesim.com hosts.
const v3OrDefault = (
  valueV3: string | undefined,
  fallback: string | undefined,
): string =>
  isBaseUrlV3() && (valueV3 ?? "") !== "" ? (valueV3 ?? "") : (fallback ?? "");

// Media host (QR codes, affiliate, card and carrier logos). `path` is relative
// to the root.
export const getImageUrl = (path: string = ""): string => {
  const base = v3OrDefault(
    process.env.GATSBY_IMAGE_URL_V3,
    process.env.GATSBY_IMAGE_URL,
  );
  return `${base.endsWith("/") ? base : `${base}/`}${path.replace(/^\/+/, "")}`;
};

// Customer Care chat: API, socket, and the support board it falls back to.
export const getCcApiBaseUrl = (): string =>
  v3OrDefault(
    process.env.GATSBY_CC_API_BASE_URL_V3,
    process.env.GATSBY_CC_API_BASE_URL,
  );

export const getCcSocketUrl = (): string =>
  v3OrDefault(
    process.env.GATSBY_CC_SOCKET_URL_V3,
    process.env.GATSBY_CC_SOCKET_URL,
  );

export const getSupportBoardUrl = (): string =>
  v3OrDefault(
    process.env.GATSBY_SUPPORT_BOARD_URL_V3,
    process.env.GATSBY_SUPPORT_BOARD_URL,
  );

export const getProfileUrl = (): string => {
  if (isBaseUrlV3()) {
    return process.env.GATSBY_PROFILE_URL_V3 || "";
  }
  if (isBaseUrlV2()) {
    return process.env.GATSBY_PROFILE_URL_V2 || "";
  }
  return process.env.GATSBY_PROFILE_URL || "";
};

export const getWalletUrl = (): string => {
  if (isBaseUrlV3()) {
    return process.env.GATSBY_WALLET_URL_V3 || "";
  }
  if (isBaseUrlV2()) {
    return process.env.GATSBY_WALLET_URL_V2 || "";
  }
  return process.env.GATSBY_WALLET_URL || "";
};
